export const ATTEMPT = 'transfer/ATTEMPT';
export const VIEW_ENTER = 'transfer/VIEW_ENTER';
export const CONFIRM = 'transfer/CONFIRM';
export const REJECT = 'transfer/REJECT';
export const REQUEST = 'transfer/REQUEST';
export const SUCCESS = 'transfer/SUCCESS';
export const FAILURE = 'transfer/FAILURE';
export const PIN_FAILURE = 'transfer/PIN_FAILURE';

export const attempt = (slipId) => ({
  type: ATTEMPT,
  slipId
});

export const viewEnter = () => ({
  type: VIEW_ENTER
});

export const confirm = () => ({
  type: CONFIRM
});

export const reject = () => ({
  type: REJECT
});

export const request = (pin) => ({
  type: REQUEST,
  pin
});

export const success = () => ({
  type: SUCCESS
});

export const failure = (error) => ({
  type: FAILURE,
  error
});

export const pinFailure = (error) => ({
  type: PIN_FAILURE,
  error
});
